// ----
// This is where all of the site-specific JS goes. This is the site's main JS file, so make your JS defensive.
// It's created using the JS Module Pattern (http://addyosmani.com/resources/essentialjsdesignpatterns/book/#modulepatternjavascript)
// Usage: SCM.SiteJS.functionName();  Can be used anywhere in the application.
// ----

var SCM = SCM || {};

(function (ns, $) {
    // ----
    // private variables and functions
    // ----
    var $body = $('body');
    var lastTriggeringLink = null;
    var DefaultRevealCloseLabel = 'Close modal';

    function _lockBodyScroll() {
        var scrollY = window.scrollY !== undefined ? window.scrollY : window.pageYOffset;
        $body.data('revealScrollY', scrollY)
             .css({ position: 'fixed', top: -scrollY + 'px', width: '100%' });
        $('<div class="reveal-modal-backdrop"></div>').appendTo($body);
    }

    function _unlockBodyScroll() {
        var savedScrollY = parseInt($body.data('revealScrollY') || 0, 10);
        $body.css({ position: '', top: '', width: '' })
             .removeClass('on-canvas');
        $('.reveal-modal-backdrop').remove();
        window.scrollTo(0, savedScrollY);
    }

    // Publish scrollbar width so modal scroll-lock CSS can reserve it (must run before any modal opens).
    ns.setScrollbarWidthProperty = function () {
        var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        document.documentElement.style.setProperty('--scrollbar-width', scrollbarWidth + 'px');
    };

    // ----
    // Many Pages / Global
    // ----

    ns.skipToMainContent = function () {
        $('.skipnav').on('click', function () {
            $('#skipNav').focus();
        });
    };

    // RSCJ-315: Remove autosuggest hint inputs from tab order and screen readers.
    // These text inputs sit behind the real search input (z-index: -1) to show
    // ghost text. They should never receive focus or be announced. The view-level
    // fix in SiteSearch.cshtml covers the header instance; this JS catches any
    // additional instances rendered by SelfServe content (e.g. hero search forms).
    ns.hideAutoSuggestHintInputs = function () {
        $('.microsite-search-term-input-hint').each(function () {
            this.tabIndex = -1;
            this.disabled = true;
            this.setAttribute('aria-hidden', 'true');

            // Also hide the associated label — aria-hidden on the input does not
            // silence its label (they are separate nodes in the accessibility tree).
            const label = document.querySelector('label[for="' + this.id + '"]');
            if (label) {
                label.setAttribute('aria-hidden', 'true');
            }
        });
    };

    ns.globalNavDropdown = function () {
        $('.js-dropdown-trigger').on('click', function (e) {
            $('body').addClass('on-canvas');
            var currentMenu = $(this).next('.js-dropdown');
            e.stopPropagation();
            $('div, nav').not(currentMenu).removeClass('expanded');
            currentMenu.toggleClass('expanded');
            $(document.body).on('click', function (ev) {
                if (!$(ev.target).closest('.js-dropdown.expanded').length || $(ev.target).hasClass('js-menu-close')) {
                    $('.js-dropdown').removeClass('expanded');
                    $('body').removeClass('on-canvas');
                }
            });
        });

        // Close the global nav when keyboard focus leaves the dropdown (e.g. user
        // tabs past the last item). focusout bubbles, so listening on the dropdown
        // catches focus changes on any descendant; relatedTarget is the element
        // about to receive focus (null when focus leaves the document entirely).
        $('.global-nav-dropdown').on('focusout', function (e) {
            var dropdown = this;
            var nextFocus = e.relatedTarget;
            if (nextFocus && dropdown.contains(nextFocus)) {
                return;
            }
            var trigger = $(dropdown).prev('.js-dropdown-trigger')[0];
            if (nextFocus && trigger === nextFocus) {
                return;
            }
            $(dropdown).removeClass('expanded');
            $('body').removeClass('on-canvas');
        });

        // Escape closes the dropdown and returns focus to the trigger
        // (WAI-ARIA disclosure pattern).
        $('.global-nav-dropdown').on('keydown', function (e) {
            if (e.key !== 'Escape' && e.key !== 'Esc') {
                return;
            }
            var $dropdown = $(this);
            if (!$dropdown.hasClass('expanded')) {
                return;
            }
            var trigger = $dropdown.prev('.js-dropdown-trigger')[0];
            $dropdown.removeClass('expanded');
            $('body').removeClass('on-canvas');
            if (trigger) {
                trigger.focus();
            }
        });
    };

    // ----
    // Check for JS 
    // ----
    ns.checkForJS = function () {
        $('html').removeClass('no-js');
    };

    // ----
    // Browser Checks
    // ----
    ns.detectIfIE = function () {
        function GetIEVersion() {
            var sAgent = window.navigator.userAgent;
            var Idx = sAgent.indexOf('MSIE');

            // If IE, return version number.
            if (Idx > 0) {
                return parseInt(sAgent.substring(Idx + 5, sAgent.indexOf('.', Idx)));
            }
            // If IE 11 then look for "Trident" in user agent string.
            else if (!!navigator.userAgent.match(/trident/gi)) {
                return 11;
            }
            else {
                return 0; //It is not IE
            }
        }

        var ieVersion = GetIEVersion();

        if (ieVersion > 0 && ieVersion < 13) {
            $('html').addClass('IE IE-' + ieVersion);
        } else {
            return;
        }
    };

    ns.detectIfFirefox = function () {
        var FF = !(window.mozInnerScreenX == null);
        if (FF) {
            $('html').addClass('firefox');
        }
        else {
            return;
        }
    };

    ns.closeModals = function () {
        $(document).on('click', '.close-reveal-modal', function () {
            _closeModal();
        });
        // When user clicks anywhere outside the modal, close it
        $('body').on('click', function (e) {
            if ($(e.target).is('.mobile-mask')) {
                _closeModal();
            }
        });
        // Clicking on our injected backdrop closes the reveal modal.
        $(document).on('click', '.reveal-modal-backdrop', function () {
            _closeModal();
        });
        $(document).on('keydown', function (e) {
            if (e.key === 'Escape' || e.keyCode === 27) {
                // Foundation may handle Escape before us and remove .open,
                // so check for our backdrop instead of .reveal-modal.open.
                if ($('.reveal-modal-backdrop').length > 0) {
                    _closeModal();
                }
            }
        });

        function _closeModal() {

            var $revealModal = $('.reveal-modal.open');

            if ($revealModal.is('[content-id]')) {
                return;
            }

            // Guard against double-invocation from two close triggers firing in quick succession.
            if (!$revealModal.length && !lastTriggeringLink) {
                return;
            }

            $revealModal
                .removeAttr('aria-labelledby')
                .attr('aria-hidden', 'true')
                .removeClass('open');

            $('#revealModal').removeClass('fig-modal');
            $('#revealModal').children('.close-reveal-modal').find('.screenreader-text').text(DefaultRevealCloseLabel);

            _unlockBodyScroll();

            // Clear the focus-trap flag so the Reveal MutationObserver's release
            // path does not run and overwrite our manual restoration with a
            // _getClosestFocusableElement walk-up (which would land on the
            // skip-to-main-content link). WCAG 2.4.3 — ACS-1144.
            $('#revealModal').data('focusTrapped', false);

            if (lastTriggeringLink) {
                var $trigger = _visibleFocusReturnTarget(lastTriggeringLink);
                lastTriggeringLink = null;
                $trigger[0].focus({ preventScroll: true });
            }
        }

        // A trigger inside a popup that has since closed cannot take focus, so return it to the popup's opener (ACS-1641).
        function _visibleFocusReturnTarget($trigger) {
            var $popupOpener = $();
            if ($trigger.is(':visible')) {
                return $trigger;
            }
            $trigger.parents('[id]').filter(':hidden').each(function () {
                var popupId = this.id;
                $popupOpener = $('[aria-controls]').filter(function () {
                    return this.getAttribute('aria-controls') === popupId;
                }).filter(':visible');
                return !$popupOpener.length;
            });
            return $popupOpener.length ? $popupOpener.first() : $trigger;
        }
    };

    ns.alignModalsVerically = function () {
        //1.5rem Padding between bottom of pade header and top of modal
        //Keep in mind "close" button extends over the top of the modal
        //var headerModalPadding = 24;
        //This function will trigger on page load as well as when ajax complete is triggered
        $('.reveal-modal').css('top', '25vh');
    };

    ns.setAllLinksTarget = function () {
        $('a:not([target="_blank"])').each(function () {
            if (linksToAnotherPage(this.href) && linksToExternalPage(this.href)) {
                this.target = '_blank';
                // Instead of binding a Click event to every link on the page, set the
                // `target` attribute to achieve the same effect and improve performance.
            }
        });

        // Returns true if the link actually goes to a different page (as oppposed to being a js only link)
        function linksToAnotherPage(linkHref) {
            return linkHref && (linkHref.startsWith('http') || linkHref.startsWith('/')) && !linkHref.startsWith('#');
        }

        // Returns true if host of the href doesn't match the current page
        function linksToExternalPage(linkHref) {
            if (linkHref.startsWith('/')) {
                return false;
            }

            var hostRegEx = new RegExp('/' + window.location.host + '/');
            return !hostRegEx.test(linkHref);
        }
    };

    ns.initSelfServeNavigation = function () {
        var $currentLink = $('.widget-SelfServeContentNavigationMenu a[href="' + window.location.pathname + '"]');
        $currentLink.addClass('ss-currentPage');
        $currentLink.parents('ul.selfserve-nav-menu-child-list').addClass('open');
        $currentLink.parents('ul.selfserve-nav-menu-child-list').siblings('button.selfserve-subnav-toggle').removeClass('icon-general-arrow-filled-right').addClass('icon-general-arrow-filled-down');
    };

    ns.toggleSelfServeNavigation = function () {
        $('.selfserve-subnav-toggle, .selfserve-parent-toggle').on('click', function (e) {
            var $this = $(this),
                $nearestSublist = $(this).siblings('.selfserve-sublist');

            e.preventDefault(); // stop button from submitting the page form

            $this.hasClass('icon-general-arrow-filled-right') ? $this.removeClass('icon-general-arrow-filled-right').addClass('icon-general-arrow-filled-down') : $this.removeClass('icon-general-arrow-filled-down').addClass('icon-general-arrow-filled-right');
            $nearestSublist.hasClass('open') ? $nearestSublist.removeClass('open') : $nearestSublist.addClass('open');
        });
    };

    ns.getViewportWidth = function () {
        return Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    };

    ns.showFunderInfo = function () {
        $('.js-linked-funder-name').on('click', function (e) {
            var $targetModal = $(this).siblings('.fl-funder-info-wrap');
            e.stopPropagation();
            $('.fl-funder-info-wrap').not($targetModal).removeClass('open');
            $($targetModal).toggleClass('open');
            $('body').addClass('leftRailModalOpen');
        });
    };

    ns.hideFunderInfo = function () {
        $(document.body).on('click', function (e) {
            if (!$(e.target).parents('.al-funder-info-wrap').length) {
                $('.al-funder-info-wrap').removeClass('open');
                $('body').removeClass('leftRailModalOpen');
            }
        });
    };

    ns.showArticleMetadata = function () {

        //hide empties if js-metadata-wrap is empty
        $('.js-expand-collapse-metadata').each(function () {
            var parent = $(this).parent();
            var content = parent.next('.js-metadata-wrap');

            if (content.children().length === 0) {
                parent.addClass('hide');
            }
        });


        $('.js-expand-collapse-metadata').on('click', function () {
            var $ariaControl = $(this);
            const expanded = $ariaControl.attr('aria-expanded') === 'true';
            if (expanded) {
                $ariaControl.attr('aria-expanded', 'false');
            } else {
                $ariaControl.attr('aria-expanded', 'true');
            }

            var $container = $ariaControl.parent();
            $container.toggleClass('active');

            var $icon = $ariaControl.find('.js-metadata-toggle-icon');
            $icon.toggleClass('icon-general-add');
            $icon.toggleClass('icon-general_minus');
        });
    };

    ns.scrollToAwardInfo = function () {
        $(document).on('click', 'a.js-xref-award', function () {

            var $articleTopInfo = $('.js-author-expand-collapse-metadata-wrap');
            if ($articleTopInfo.length && !$articleTopInfo.hasClass('active')) {
                $('.js-expand-collapse-metadata').click();
            }

            var targetAwardGroup = $(this).data('scrollto');
            var $target = $('div.award-group[data-award-id=' + targetAwardGroup + ']');

            if ($('.pg_Article').length) {
                $('html,body').delay(100).animate({
                    scrollTop: $target.offset().top - 65
                }, 250);
            }
            else {
                var $targetScroll = $('.js-content-splitview');
                $targetScroll.delay(100).animate({
                    scrollTop: $targetScroll.scrollTop() + $target.position().top
                }, 250);
            }
        });
    };

    ns.addAuthorFootnote = function () {
        $('.al-author-name').each(function () {
            var $authorNote = $(this).find('.info-card-note .xref-fn');
            if ($authorNote.length && $authorNote.text() === '*') {
                var $footNote = $('<sup/>').append($authorNote.html());
                $footNote.insertAfter($(this).find('.linked-name'));
                $authorNote.remove();
            }
            var enableCorrespondingAuthorIcon = $('#js-hdn-enable-corresponding-author-icon').val() == 'True';
            if (enableCorrespondingAuthorIcon && $(this).find('.info-author-correspondence').length) {
                $(this).find('.js-linked-name').append(`<i class="icon-corresponding_author" title="Corresponding Author" aria-label="Corresponding Author">
                <span class="screenreader-text">Corresponding Author</span>
                </i>`);
            }
        });
    };

    ns.showHideDropDown = function () {
        $('.selectDropdown').on('click', function (e) {
            $('.dropdown').hide().removeClass('open');
            e.stopPropagation();
            $(this).siblings('.dropdown').slideToggle('300', 'linear').toggleClass('open');
        });

        $(document).click(function () {
            $('.dropdown').hide().removeClass('open');
        });
    };


    ns.showMoreRelatedContent = function (viewMoreSelector, hideMeSelector) {
        $(viewMoreSelector).click(function () {
            var $this = $(this);
            $this.closest('.related-section-box, .widget-RelatedBookContent').find(hideMeSelector).toggleClass('show-item');
            $this.toggleClass('show-less').find('i').toggleClass('icon-show').toggleClass('icon-hide');
            $this.hasClass('show-less') ? $this.find('span').text('See Less') : $this.find('span').text('See More');
        });
    };

    ns.showSpinner = function () {
        $('.pagination button, .querybuilder-submit').on('click', function () {
            $('.preloader-wrap').removeClass('hide').addClass('active');
        });
    };

    ns.isLoggedIn = function () {
        return App.LoginUserInfo.isIndividualLoggedIn > 0;
    };

    // ----
    // START: Mobile Site Nav & Search
    // ----

    ns.toggleSearchCover = function () {
        if ($('.sf-facet').length) {
            $('.sf-facet').on('click', function () {
                $(document).off('ajaxStart.search-cover').on('ajaxStart.search-cover', function () {
                    $('.info-inner-cover').removeClass('uncovered');
                    $('.info-inner-cover').addClass('covered');
                });
                $(document).off('ajaxComplete.search-cover').on('ajaxComplete.search-cover', function () {
                    $('.info-inner-cover').removeClass('covered');
                    $('.info-inner-cover').addClass('uncovered');
                });
            });
        }
    };

    // ----
    // START: Responsive Left Column
    // ----
    ns.toggleResponsiveLeftColumn = function () {
        $(document.body).removeClass('noscroll'); // remove if page reloads as a result of a filter being selected

        $('.js-main').on('click', '.toggle-left-col__search, .toggle-left-col__article', function (e) {
            e.preventDefault();
            $(document.body).addClass('noscroll');
            $('.page-column--left').show();

            $(document).one('ajaxComplete', function () {
                $(document.body).removeClass('noscroll');
            });
        });

        $('.toggle-left-col__close').on('click', function (e) {
            e.preventDefault();
            $(document.body).removeClass('noscroll');
            $('.page-column--left').removeAttr('style');
        });
    };

    // ----
    // END: Responsive Left Column
    // ----

    // ----
    // Advanced Search Page
    // ----
    ns.initDatePicker = function () {
        if ($('.pg_advancedsearch').length && ($('#startDateAuthor').length || $('#startDateSemanticSearch').length)) {
            // Native <input type="date"> fields provide their own picker (used when inline date
            // validation is enabled) — don't attach the jQuery UI datepicker to them.
            $('#startDateAuthor, #endDateAuthor, #startDateSemanticSearch, #endDateSemanticSearch')
                .not('[type="date"]')
                .datepicker();
        }
    };

    // ----
    // Content Pages
    // ----

    ns.showFullAuthorList = function () {
        var $showMoreLink = $('.meta-authors--etal');
        var $remainingAuthors = $('.meta-authors--remaining');


        $showMoreLink.on('click', function (e) {
            e.preventDefault();
            $showMoreLink.removeClass('is-active');
            $showMoreLink.attr('aria-hidden', true);

            $remainingAuthors.addClass('is-active');
            $remainingAuthors.attr('aria-hidden', false);

        });
    };

    // lazy load is triggered by scroll. If we append this content into a modal -- it might not appear.
    // This forces the images to appear
    ns.showImages = function ($obj) {
        $obj.find('.contentFigures').each(function () {
            var elem = $(this);
            if (elem.attr('src').toLowerCase().indexOf('grey.gif') >= 0) {
                elem.attr('src', elem.attr('data-original'));
            }
        });
    };

    function _wireImageDescriptionToggles() {
        if (SCM.ImageDescriptionToggle && SCM.ImageDescriptionToggle.init) {
            SCM.ImageDescriptionToggle.init();
        }
    }

    // There is generic modal div wrapper in site.master where we append any content that needs to be put in a modal
    ns.openRevealModal = function ($obj) {
        $('.reveal-modal').removeClass('open');
        var modal = $('#revealModal');
        modal.find('#revealContent').empty().prepend($obj.clone());
        modal.find('#revealContent img.lazy').each(function() {
            SCM.Utilities.LazyLoad.updateImageSrc(this);
            $(this).removeClass('lazy');
        });
        _wireImageDescriptionToggles();
        $('body').addClass('on-canvas');
        // Center-align the modal for figures (fig-modal) and tables (table-wrap);
        // footnotes and equations use left-aligned layout.
        var isFigOrTableContent = $obj.hasClass('fig-modal') || $obj.find('.fig-modal').length > 0
            || $obj.hasClass('table-wrap') || $obj.find('.table-wrap').length > 0;
        modal.closest('.reveal-modal')
            .addClass(isFigOrTableContent ? 'open fig-modal' : 'open')
            .removeAttr('aria-labelledby')
            .attr('aria-hidden', 'false');

        var $labelElement = modal.find('.title-label').first();
        var labelId = $labelElement.length ? $labelElement.attr('id') : null;
        if (labelId) {
            modal.attr('aria-labelledby', labelId);
        }

        // #revealModal is a shared shell reused for every piece of content it is handed, so its single
        // close button would otherwise be named identically no matter what is open. Name it after the
        // content currently shown.
        var titleText = $labelElement.length ? $.trim($labelElement.text()) : '';
        modal.children('.close-reveal-modal').find('.screenreader-text')
            .text(titleText ? 'Close ' + titleText + ' modal' : DefaultRevealCloseLabel);

        // Mark trapped before invoking so the Reveal MutationObserver does not
        // re-trap this modal — re-trapping overwrites the saved trigger element
        // with a focusable inside the modal. The trigger is restored manually
        // in _closeModal via lastTriggeringLink (WCAG 2.4.3 — ACS-1144).
        modal.closest('.reveal-modal').data('focusTrapped', true);
        SCM.Focus.trap(modal);

        if (modal.length) {
            SCM.SiteJS.removeDuplicateFootnotes(modal);
        }

        SCM.SiteJS.showImages(modal);
        SCM.SiteJS.restrictedImages();
    };

    ns.processFigGroup = function (modalTriggerId, $groupContainerDiv) {
        $('.reveal-modal').removeClass('open');
        var $figGroupItems = $('[reveal-group-id~="' + modalTriggerId + '"]');
        if ($figGroupItems.length && $groupContainerDiv.length) {
            if (!$groupContainerDiv.children().length) {
                if ($figGroupItems.length) {
                    $figGroupItems.each(function () {
                        $groupContainerDiv.append($(this).clone().removeClass('hide'));
                    });
                    _wireImageDescriptionToggles();
                }
            }
            $('body').addClass('on-canvas');
            $groupContainerDiv.addClass('open');
            SCM.SiteJS.showImages($groupContainerDiv);
            SCM.SiteJS.restrictedImages();
        }
    };
    ns.processNonFigGroup = function (revealId, needSubscriptionModal,revealDistinct) {
        // content-id might contain multiple, space-separated IDs
        // (P.S. the "i" at the end means "case-insensitive"! it's standard CSS, apparently!)
        var revealContent = $('.js-main [content-id~="' + revealId + '" i]');

        if (revealContent.length > 1 && revealDistinct) {
            revealContent = revealContent.first();
        }

        if (revealId.length && !revealContent.length) {
            var resArry = revealId.split(' ');
            if (resArry.length) {
                var rangeContent = ns.getAllReferencesInRange(resArry);
                revealContent = rangeContent.html().length > 0 ? rangeContent : '';
            }
        }

        // Brightcove HTML5 player doesn't work with cloned content
        if ($(revealContent).hasClass('video-modal') || $(revealContent).hasClass('audio-modal')) {
            SCM.Utilities.Reveal.open(revealContent);
            return;
        }

        // this is for figures inside boxed-text
        var targetModal = $('.reveal-modal[content-id="' + revealId + '"]');
        if (targetModal.length) {
            SCM.Utilities.Reveal.open(targetModal);
            return;
        }

        // Found the figure or table? Open it in reveal modal. Otherwise, you must not have access to the content and
        // we'll show you the need account message.
        revealContent.length ? SCM.SiteJS.openRevealModal(revealContent) : SCM.Utilities.Reveal.open(needSubscriptionModal);
    };

    ns.removeDuplicateFootnotes = function ($content) {
        var copiedContent = {};

        var $contentChildren = $content.children('#revealContent').children('.fn');

        $($contentChildren).each(function () {
            var txt = $(this).text();
            if (copiedContent[txt]) {
                $(this).remove();
            }
            else {
                copiedContent[txt] = true;
            }
        });
    };

    ns.revealFigsTablesInModal = function () {
        var modalTriggerElems = '.xref-fn, .link-reveal, .table-graphic, .caption-title';

        var needSubscriptionModal = $('#NeedSubscription');

        $body.on('click', modalTriggerElems, function () {
            var $this = $(this);
            // Ensure the trigger can receive programmatic focus on modal close.
            // Some xref triggers (e.g. xref-corresp without href) are <a> elements
            // that the browser refuses to focus; tabindex="-1" allows .focus()
            // without making them tab-stoppable (WCAG 2.4.3 — ACS-1144).
            if (!$this.attr('href') && typeof $this.attr('tabindex') === 'undefined') {
                $this.attr('tabindex', '-1');
            }
            lastTriggeringLink = $this;
            _lockBodyScroll();
            var revealDistinct = $(this).hasClass('js-reveal-distinct');
            var rightPaneItem = $this.hasClass('xref-bibr');
            if ($('.pg_articlesplitview').length > 0 && rightPaneItem) {
                return;
            }

            var revealId = $this.attr('reveal-id') ? $this.attr('reveal-id')
                : $this.attr('data-reveal-id') ? $this.attr('data-reveal-id')
                    : $this.attr('data-id');

            var $groupContainerDiv = $('.js-main div[reveal-group-container-id="' + revealId + '" i]');

            if ($groupContainerDiv.length) {
                SCM.SiteJS.processFigGroup(revealId, $groupContainerDiv);
            } else {
                SCM.SiteJS.processNonFigGroup(revealId, needSubscriptionModal,revealDistinct);
            }

            if (SCM && SCM.RelatedObjectLinks && SCM.RelatedObjectLinks.initContentWithinModal) {
                SCM.RelatedObjectLinks.initContentWithinModal();
            }
        });

    };


    ns.getAllReferencesInRange = function (list) {
        var modalContent = $('<div/>');
        var contentItem;
        list.forEach(function (id) {
            contentItem = $('.js-main [content-id~="' + id + '" i]').first();
            modalContent.append(contentItem.clone().removeClass('reveal-modal'));
        });

        return modalContent;
    };

    ns.showUnAuthenticatedSpans = function () {
        // For un-authenticated users, replace reveal-modal links with spans, since target of link is 99.99% likely to be missing
        $(document).ready(function () {
            var hasAccess = $('div[data-widgetname="ArticleFulltext"] span#UserHasAccess').attr('data-userHasAccess');
            if (hasAccess && hasAccess.length && hasAccess.toLowerCase() === 'false') {
                var revealModalLinks = $('div[data-widgetname="ArticleFulltext"] a[data-reveal-id]');
                revealModalLinks.each(function () {
                    $(this).replaceWith(function () {
                        var anchorHtml = this.innerHTML;
                        return '<span>' + anchorHtml + '</span>';
                    });
                });
            }
        });
    };

    ns.jumpToPeerReview = function () {
        var peerReviewId = SCM.JSUtility.getSearchParamByName('peerReviewId');

        if (peerReviewId) {
            var $peerReviewTarget = $(document.getElementById(peerReviewId));

            if ($peerReviewTarget.length && $('.pg_Article').length) {
                $('html,body').delay(100).animate({
                    scrollTop: $peerReviewTarget.offset().top - 65
                },
                    250);
            }
        }

    };

    function setupTablesViewLarge() {
        var $body = $('body.pg_article, body.pg_articlesplitview');
        if (!$body.length) {
            return;
        }

        // Because this content is a dynamic widget in some views, we can't do this work on document.ready,
        // since it might not be on the page yet.  So do it on the first mouseover.
        $body.on('mouseover', '.table-wrap a.jumplink-placeholder', function (e) {
            var $imageLink = $(e.currentTarget);
            var sectionid = $imageLink.data('sectionid');
            if (isValidSectionId(sectionid)) {
                $imageLink.removeClass('jumplink-placeholder');
            }
        });

        $body.on('click', '.table-wrap a', function (e) {
            var $target = $(e.currentTarget);
            var sectionid = $target.data('sectionid');
            if (isValidSectionId(sectionid)) {
                e.preventDefault();
                var url = '/view-large/' + sectionid;
                if ($target.parent('.fig-graphic').length) {
                    var filename = $target.data('filename') || $target.attr('id');
                    url = '/view-large/figure/' + sectionid + '/' + filename;
                }
                window.open(url, '_blank');
            }
        });

        function isValidSectionId(sectionid) {
            return sectionid && sectionid !== '[XSLTSectionID]';
        }
    }


    // ----
    // START: Site Header
    // ----

    var signInLoaded = false;

    ns.loadSignInForm = function (loginFormLocation) {
        var $mobileSignInForm = $('.mobile-account-dropdown ul li ul'),
            $desktopSignInForm = $('.dropdown-panel-signin'),
            $signInPageForm = $('#sign-in-page'),
            returnUrl = SCM.SiteJS.addPeerReviewDataToUrl(SCM.SiteJS.getDefaultReturnUrl());
        if (!signInLoaded) {
            // Get the login form markup with AJAX
            var widgetUrl = (App.CurrentSubdomain.length ? '/' + App.CurrentSubdomain : '') + loginFormLocation + encodeURIComponent(returnUrl);
            SCM.Ajax.get(widgetUrl)
                .expectHtml()
                .then(function (data) {
                    $desktopSignInForm.html(data);
                    $mobileSignInForm.html(data);
                    $signInPageForm.html(data);
                    SCM.AddReturnUrlToSocietyLinks();
                    signInLoaded = true;

                    if ($('.dropdown-menu').length > 0) {
                        var displayInSigninForm = $('.dropdown-menu').data('displayinloginform');
                        if (displayInSigninForm) {
                            $('.dropdown-menu').clone().prependTo('.myAccountNav.login-myaccount-wrap, .js-login-wrap');
                        }
                    }

                })
                .then(function () {
                    let $instAdminLinkWrap = $('.inst-admin-link-wrap');

                    if ($instAdminLinkWrap.length && $instAdminLinkWrap.data('moveToInstDropdown') === true) {
                        $instAdminLinkWrap.appendTo('.inst-admin-link-placeholder');
                    }
                })
                .catch(function (reason) {
                    console.error('Failed to load sign-in form: ' + reason);
                });
        }
    };

    ns.initSigninForm = function () {
        var $desktopSignInToggle = $('.dropdown-toggle.signin');

        //DESKTOP signin from dropdown
        $desktopSignInToggle.on('click', function () {
            var loginFormLocation = $(this).data('login-location');
            ns.loadSignInForm(loginFormLocation);
        });

        // button login
        $(document.body).on('click', '.signin-form .signin-button', function (e) {
            var $closestSigninForm = $(this).closest('.signin-form'),
                $closestSpinner = $closestSigninForm.find('.preloader-wrap');
            e.preventDefault();
            e.stopPropagation();

            SCM.SiteJS.Login($closestSigninForm, $closestSpinner);
        });

        // Enter key login
        $(document).on('keypress', '.signin-form input.username, .signin-form input.password', function (e) {
            var $closestSigninForm = $(this).closest('.signin-form'),
                $closestSpinner = $closestSigninForm.find('.preloader-wrap');
            var code = e.keyCode || e.which;
            if (code === 13) {
                e.preventDefault();
                SCM.SiteJS.Login($closestSigninForm, $closestSpinner);
            }
        });

        // Log Out
        $(document).on('click', '.signout-button', function (e) {
            var href = e.target.getAttribute('href') || $(this).attr('href');

            if (href && href !== '' && href !== '#' && href !== 'javascript:;') {
                return; 
            }
            
            // don't do ajax call, since the logouthandler may issue its own redirection e.g. Single Sign out. It will be default go back to /.
            e.preventDefault();
            var logoutHandler = '/LogoutHandler.ashx';
            var logoutType = e.target.attributes['logout-type'];

            if (logoutType) {
                logoutHandler += '?logoutType=' + logoutType.value;
            }

            window.top.location.assign(logoutHandler);
        });

        // Institutional login, append returnUrl
        $(document).on('click', 'a.institutional-login-link', function (e) {
            e.preventDefault();

            var targetUrl = $(this).attr('href');

            var targetUrlLowerCase = targetUrl.toLowerCase();

            // skip if the target already has a returnUrl, or if current page is the target 
            // For simplicity, we won't check possibly various formats in front of the pathname - a mismatch won't be a big deal
            if (!(targetUrlLowerCase.indexOf('returnurl=') > 0 || window.top.location.href.toLowerCase().indexOf(targetUrlLowerCase) >= 0)) {
                // pass through returnUrl from current page
                var returnUrl = SCM.JSUtility.getSearchParamByName('returnUrl');

                if (returnUrl === undefined || returnUrl === null) {
                    returnUrl = window.top.location.href; // full URL, in case there is a sub domain while a shibboleth login can only have one default sign in page
                }

                // append returnUrl to target
                if (returnUrl && returnUrl.length > 0) {
                    targetUrl = $.param.querystring(targetUrl, 'returnUrl=' + encodeURIComponent(returnUrl));
                }
            }

            window.top.location.assign(targetUrl);
        });

        // Shibboleth login
        $(document).on('click', 'a.shibboleth-signin', function () {
            var currLocation = window.top.location;
            var shibbolethHandlerUrl = currLocation.origin + '/SHIBBOLETH?dest=' + encodeURIComponent(currLocation.pathname + currLocation.search);
            var shibbolethUrl = $(this).data('target').replace('{0}', encodeURIComponent(shibbolethHandlerUrl));

            window.top.location = shibbolethUrl;
        });

    };

    ns.initLoginFormDropdown = function () {
        $('.signin-form').on('click', 'a[data-target="register"]', function (e) {
            e.preventDefault();

            var returnUrl = SCM.JSUtility.getSearchParamByName('returnUrl');
            if (returnUrl === undefined || returnUrl === null) {
                returnUrl = location.pathname + location.search;
            }

            window.top.location.assign('/my-account/register?returnUrl=' + encodeURIComponent(returnUrl));
        });
    };

    ns.showAlertMessage = function ($el, message) {
        $el.empty().removeAttr('role').show();
        setTimeout(function () {
            $el.attr('role', 'alert').html(message);
        }, 100);
    };

    ns.Login = function ($formContainer, $formSpinner) {

        var recaptchaResponse = SCM.Captcha.GetCaptchaResponse($formContainer);
        var enableReCaptcha = $formContainer.find('input#enableReCaptcha').val() ?? 'true';
        const $UsernameInput = $formContainer.find('input.username');
        const $PasswordInput = $formContainer.find('input.password');
        const Username = $UsernameInput.val();
        const Password = $PasswordInput.val();

        if (Username.length === 0 || Password.length === 0) {
            var $error = $formContainer.find('.error');
            SCM.SiteJS.showAlertMessage($error, $error.data('default-message'));
            $UsernameInput.attr('aria-invalid', 'true');
            $PasswordInput.attr('aria-invalid', 'true');
            $UsernameInput.focus();
            return;
        }

        $formSpinner.removeClass('hide');
        $('.error, .no-permission').removeAttr('role').empty().hide();
        $UsernameInput.removeAttr('aria-invalid');
        $PasswordInput.removeAttr('aria-invalid');

        var loginWidgetElement = $formContainer.closest('.widget-LoginForm');
        var loginWidgetClassName = '';
        if (loginWidgetElement.length) {
            loginWidgetClassName = loginWidgetElement[0].className;
        }
        
        let captchaWidgetInstance = SCM.Captcha.GetCaptchaInfo().ReCaptchaWidgetControlId;
      
        SCM.Ajax.post('/LoginHandler.ashx', { user: Username, pass: Password, enableReCaptcha: enableReCaptcha, recaptchaResponse: recaptchaResponse, captchaInstanceName: captchaWidgetInstance })
            .expectJson()
            .then(function (result) {
                if (result.LoginSuccess) {
                    if (SCM.GoogleTagManagerDataLayerEvents) {
                        var returnUrl = SCM.SiteJS.getDefaultReturnUrl();
                        SCM.GoogleTagManagerDataLayerEvents.logSuccessfulAction(returnUrl, loginWidgetClassName,'signin');
                    }
                    SCM.SiteJS.loginReturnBack();
                } else if (result.UnverifiedUser) {
                    var $noPerm = $formContainer.find('.error');
                    SCM.SiteJS.showAlertMessage($noPerm, result.ErrorMessage);
                    $UsernameInput.attr('aria-invalid', 'true');
                    $PasswordInput.attr('aria-invalid', 'true');
                    $UsernameInput.focus();
                    SCM.Captcha.ResetCaptcha($formContainer);
                } else {
                    var $err = $formContainer.find('.error');
                    SCM.SiteJS.showAlertMessage($err, $err.data('default-message'));
                    $UsernameInput.attr('aria-invalid', 'true');
                    $PasswordInput.attr('aria-invalid', 'true');
                    $UsernameInput.focus();
                    SCM.Captcha.ResetCaptcha($formContainer);
                }
            })
            .catch(function (reason) {
                console.error('Login failure: ' + reason);
                var $err = $formContainer.find('.error');
                SCM.SiteJS.showAlertMessage($err, $err.data('default-message'));
                $UsernameInput.attr('aria-invalid', 'true');
                $PasswordInput.attr('aria-invalid', 'true');
                $UsernameInput.focus();
            })
            .finally(function () {
                $formSpinner.addClass('hide');
            });

    };

    ns.loginReturnBack = function () {
        var returnUrl = SCM.SiteJS.getDefaultReturnUrl();

        if (SCM.JSUtility.isBeforeSignInOnlyUrl(returnUrl)) {
            returnUrl = '/';
        }

        // PORT-593 do not return to the error pages when logging in
        var body = $('body');
        if (body.hasClass('pg_error') || body.hasClass('pg_error404')) {
            returnUrl = '/';
        }

        // only allow same domain
        if (returnUrl !== '/') {
            var returnDomainTest = returnUrl.match(/\/\/([^/]+\.)?([^./]+\.[^./]+)/i);
            if (returnDomainTest !== null && returnDomainTest[2].toLowerCase() !== window.top.location.hostname.match(/(.*\.)?([^.]+\.[^.]+)/i)[2].toLowerCase()) {
                returnUrl = '/';
            }
            else {
                returnUrl = SCM.SiteJS.addPeerReviewDataToUrl(returnUrl);
            }
        }


        window.top.location.assign(returnUrl);
    };

    ns.addPeerReviewDataToUrl = function (urlStr) {
        var peerReviewId = SCM.Common.getQueryStringValue(window.location.href, 'peerReviewId');

        if (peerReviewId) {
            var url = new URL(urlStr);
            url.searchParams.set('peerReviewId', peerReviewId);

            return url.toString();
        }

        return urlStr;
    };

    // Constructs a returnUrl
    ns.getDefaultReturnUrl = function () {
        var returnUrl = SCM.JSUtility.getSearchParamByName('returnUrl');
        if (returnUrl) {
            returnUrl = decodeURIComponent(returnUrl);
        }

        if (returnUrl === undefined || returnUrl === null || returnUrl.length === 0) {
            returnUrl = SCM.JSUtility.getSearchParamByName('redirectUrl'); // for backward compatibility
        }

        if (returnUrl === undefined || returnUrl === null || returnUrl.length === 0) {
            returnUrl = SCM.SiteJS.getCanonicalUrl();
        }

        if (returnUrl === undefined || returnUrl === null || returnUrl.length === 0) {
            returnUrl = window.top.location.pathname + window.top.location.search;
        }

        return SCM.SiteJS.preserveGuestAccessKey(returnUrl);
    };

    ns.preserveGuestAccessKey = function (returnUrl) {
        if (!returnUrl) {
            return returnUrl;
        }

        var guestAccessKey = SCM.JSUtility.getSearchParamByName('guestAccessKey');
        if (!guestAccessKey || returnUrl.indexOf('guestAccessKey=') !== -1) {
            return returnUrl;
        }

        var separator = returnUrl.indexOf('?') !== -1 ? '&' : '?';
        return returnUrl + separator + 'guestAccessKey=' + encodeURIComponent(guestAccessKey);
    };

    // returns the canonicalUrl of this page, or an empty string
    ns.getCanonicalUrl = function () {
        var canonicalUrl = $('link[rel="canonical"]').attr('href');

        if (canonicalUrl === undefined || canonicalUrl === null || canonicalUrl.length === 0) {
            return '';
        }

        return canonicalUrl;
    };

    // ----
    // Search Results
    // ----
    ns.initSearchResultsSort = function () {
        if ($('.widget-SolrSearch').length || $('#NbnjToc').length) {
            var $sortOrderSelectOption = $('.sort-order-select-option'),
                $sortOrderSelect = $('.sort-order-select'),
                $preloaderWrap = $('.preloader-wrap');

            $sortOrderSelect.off('change').on('change', function () {
                var qs = $(this).val();
                SCM.SearchResults.doSolrSearch({ queryString: qs, source: 'searchresults' });
            }); // END sortOrderSelect.on('change')

            $sortOrderSelectOption.off('click').on('click', function () {
                var lnk = $(this).find('option[value]');
                if (lnk.length) {
                    $preloaderWrap.removeClass('hide');
                }
            }); // END sortOrderListItem.on('click')
        }
    };

    ns.initSearchResultsPagination = function () {
        if (!$('.widget-SolrSearch').length) {
            return;
        }

        $(document.body).on('click', '.al-pageNumber,.sr-nav-previous,.sr-nav-next', function () {
            if ($(this).hasClass('currentPage')) {
                return;
            }
            $('.preloader-wrap').removeClass('hide');
            var url = $(this).attr('data-url');
            SCM.SearchResults.doSolrSearch({
                queryString: url,
                callback: _handleSearchCompleteCallback
            });
        });
    };    

    function _handleSearchCompleteCallback() {
        if (typeof App?.Search?.onSearchPaginationComplete === 'function') {
            App.Search.onSearchPaginationComplete();
        }
    }

    // Disable rightclick on figure context for restricted images.
    ns.restrictedImages = function () {
        $('a.fig-link[restricted]').each(function () {
            var graphicWrap = $(this).parent('div.graphic-wrap');
            var copyrightMessage = $(graphicWrap).children('.copy-right-statement');
            graphicWrap.attr('restricted', '');
            graphicWrap.off('contextmenu').on('contextmenu', function () { // right click
                $(copyrightMessage).toggle();
                return false;
            });

            $(this).click(function () { // left click on link around image
                $(copyrightMessage).toggle();
                return false;
            });

            $(copyrightMessage).click(function () { // left click on copyright message
                $(copyrightMessage).toggle();
                return false;
            });
        });
    };

    ns.moveCompetingInterestsSection = function () {
        if ($('.references-title').length) {
            $('.coi-statement-section-wrapper').insertBefore('.references-title');
        } else if ($('.backreferences-title').length) {
            $('.coi-statement-section-wrapper').insertBefore('.backreferences-title');
        } else if ($('.acknowledgements-title').length) {
            $('.coi-statement-section-wrapper').insertAfter('.acknowledgements-title');
        } else if ($('.backacknowledgements-title').length) {
            $('.coi-statement-section-wrapper').insertAfter('.backacknowledgements-title');
        }
    };

    ns.showPdfOnlyLink = function () {
        if ($('.PdfOnlyLink').length && $('.toolbar-item.item-pdf').length) {
            $('.toolbar-item.item-pdf').children().clone().appendTo('.PdfOnlyLink');
        }
    };


    // ----
    // START: Acessibility Functions (ARIA)
    // ----

    ns.ariaToggleTable = function (ariaTarget) {
        var $ariaControl = $(ariaTarget + '-button'),
            $ariaIcon = $ariaControl.children('.collapse-icon');

        $ariaControl.on('click', function (e) {
            e.preventDefault();
            //toggle aria-expanded attribute
            $ariaControl.attr('aria-expanded') === 'true' ? $ariaControl.attr('aria-expanded', 'false') : $ariaControl.attr('aria-expanded', 'true');
            // toggle arrow
            $ariaIcon.hasClass('icon-general-arrow-filled-down') ? $ariaIcon.removeClass('icon-general-arrow-filled-down').addClass('icon-general-arrow-filled-right') : $ariaIcon.removeClass('icon-general-arrow-filled-right').addClass('icon-general-arrow-filled-down');
            //toggle active class & state on the target table to show/hide it
            $(ariaTarget).toggleClass('hide');
            $(ariaTarget).attr('aria-hidden') === 'false' ? $(ariaTarget).attr('aria-hidden', 'true') : $(ariaTarget).attr('aria-hidden', 'false');
        });
    };

    ns.initAriaControls = function () {
        //tables on: academic.oupdev.silverchair.com/[JOURNAL]/subscribe/SingleIssue & CurrentYear
        var $tables = $('[id^=collapsible-table-]');
        $tables.each(function (index) {
            SCM.SiteJS.ariaToggleTable('#collapsible-table-' + index);
        });
    };

    // ----
    // START: Issue Page: ArticleListAccess.cshtml
    // ----

    ns.initializeArticlePdfLinks = function () {
        var currentArticleList = $('#ArticleList h5.item-title');

        if (currentArticleList !== null) {
            currentArticleList.each(function () {
                var article = $(this);
                var pdfLink = article.parent().find('.article-pdfLink');

                if (pdfLink !== null) {

                    if (hasAccess(article) || SCM.SiteJS.isLoggedIn()) {
                        navigateToPdfOnClick(pdfLink);
                    }
                    else {
                        navigateToSignInPageOnClick(pdfLink);
                    }
                }
            });
        }

        function hasAccess(article) {
            var articleId = article.data('resourceIdAccess');
            if (SCM.AccessIcons && articleId) {
                var accessIcon = SCM.SiteJS.getAccessIcon(articleId, SCM.AccessIcons);
                return accessIcon && accessIcon.icon !== 'icon-availability_cart';
            }

            return false;
        }

        function removeOnClickEvents(obj) {
            // Guards against a 2nd click event being added after the page has been updated via ajax
            // (see ajaxComplete)
            obj.off('click');
        }

        function navigateToPdfOnClick(pdfLink) {
            removeOnClickEvents(pdfLink);

            var articlePdfHandler = App.SiteURL + 'HTTPHandlers/ArticlePdfHandler.ashx';
            var journal = pdfLink.data('journal');
            var mmId = pdfLink.data('pdf-id');

            if (mmId !== null && journal !== null) {
                pdfLink.on('click', function (e) {
                    e.preventDefault();
                    window.open(articlePdfHandler + '?journal=' + journal + '&multimediaId=' + mmId, '_blank');
                });
            }
        }

        function navigateToSignInPageOnClick(pdfLink) {
            removeOnClickEvents(pdfLink);
            var returnUrl = SCM.SiteJS.getDefaultReturnUrl();

            pdfLink.on('click', function (e) {
                e.preventDefault();
                window.location = '/sign-in?returnUrl=' + encodeURIComponent(returnUrl);
            });
        }
    };

    // ----
    // End: Issue Page: ArticleListAccess.cshtml
    // ----

    // ----
    // END: Acessibility Functions (ARIA)
    // ----

    function referrerHostnameContains(str) {
        if (!str) {
            return false;
        }
        var referrerHostname = $('<a>', { href: document.referrer }).prop('hostname');
        return referrerHostname && referrerHostname.indexOf(str) > 0;
    }

    function shouldShowFppModal() {
        var $fppDiv = $('.js-fpp-wrap');
        if (!$fppDiv.length) {
            return false;
        }

        return $fppDiv.data('fppReferredEnabled')
            && referrerHostnameContains($fppDiv.data('fppReferredDomain'));
    }

    ns.triggerFppOnRedirect = function () {
        if (shouldShowFppModal()) {
            $('.firstPagePreviewImage').click();
        }
    };

    // For simple modals that don't copy content
    ns.modalManager = function () {
        /***********************************************************************
        * NOTE: Modals with additional logic have not been included
        * modals to add (trigger : target):
        * '.js-open-marketing-modal' : ???,
        * ********************************************************************/
        let modalArray = {
            '.js-open-saveSearch-modal': '.solrSearchSaveModel',
            '.js-add-edit-trigger': '#journalAddEditDiv',
            '[data-reveal-id="addArticleUpdateAlert"]': '#AddAlert',
            '[data-reveal-id="emailUsernameModal"]': '#emailUserName',
            '.firstPagePreviewImage': '#divFirstPagePreview',
            '[data-reveal-id="getCitations"]': '#getCitations'

        };

        function addOnClickBehavior(trigger, target) {
            $(document.body).on('click', trigger, function () {                
                var userLoginState = $(trigger).data('userloggedin');

                if (trigger !== '.js-open-saveSearch-modal' || !userLoginState) {
                    if (!(trigger === '.js-open-saveSearch-modal' && userLoginState.toLowerCase() === 'false')) {
                        $(target).closest('.reveal-modal').addClass('open');
                        $(document.body).addClass('on-canvas'); // the grey BG
                    }
                }
            });
        }

        for (var key in modalArray) {
            addOnClickBehavior(key, modalArray[key]);
        }
    };

    function setupFeaturedFigure() {
        // Wrappers whose anchor points at the article, not the image, opt out via .js-no-figure-modal.
        $('.issue-featured-image a, .featured-img-wrapper:not(.js-no-figure-modal) a, .js-issue-graphical-abstract a').on('click', function (e) {
            if (!e || !e.preventDefault) {
                return;
            }
            e.preventDefault();

            var $this = $(e.currentTarget);
            var revealContent = $this.parent().html().trim();
            var $modal = $('#revealModal');
            var $modalContent = $modal.find('#revealContent');
            var featuredFigureUrl = $this.attr('href').trim();
            if (!$modal.length || !$modalContent.length || !featuredFigureUrl || !revealContent) {
                return;
            }
            $modalContent.empty().prepend(revealContent);
            $modalContent.find('img').attr('src', featuredFigureUrl);
            $modalContent.find('.js-graphical-abstract-caption').removeClass('js-modal-only');

            $body.addClass('on-canvas');
            $modal.addClass('open');
        });
    }

    ns.ckbSelectAll = function () {
        $(document.body).on('click', '.js-ckbCheckAll', function () {
            var $this = $(this);
            var checkAllIsChecked = $this.prop('checked');

            $this.parents('.js-chkbParent').siblings().find('input[type="checkbox"]')
                .each(function (i, checkBox) {
                    var $checkBox = $(checkBox);
                    if ($checkBox.prop('checked') !== checkAllIsChecked) {
                        $checkBox.prop('checked', checkAllIsChecked)
                            .trigger('change');
                    }
                });
        });
    };

    ns.checkForEmptyArticleLeftNav = function () {
        if ($('.pg_Article').length) {
            var $objectToCheck = $('.pg_Article .info-widget-wrap > div');
            var $divToAlter1 = $('.pg_Article .info-widget-wrap').closest('.info-inner-wrap');
            var $divToAlter2 = $('.article-browse-top.article-browse-mobile-nav');
            if ($objectToCheck.length > 0) {
                $divToAlter1.removeClass('empty');
                $divToAlter2.removeClass('empty');
            }
        }
    };

    ns.mobileNav = function () {
        var $myAcctTabsInnerWrap = $('.myaccount-tabs-inner-wrap');
        var $mobileNavIcon = $('.mobile-nav-icon');

        // mobile page navigation
        $(document).on('click', '.myaccount-mobile-nav', function (e) {
            e.stopPropagation();
            $myAcctTabsInnerWrap.toggle();
            if ($mobileNavIcon.hasClass('icon-general-arrow-filled-down')) {
                $mobileNavIcon.removeClass('icon-general-arrow-filled-down').addClass('icon-general-arrow-filled-up');
            } else {
                $mobileNavIcon.removeClass('icon-general-arrow-filled-up').addClass('icon-general-arrow-filled-down');
            }
        });

        $(document).click(function () {
            $myAcctTabsInnerWrap.hide().removeAttr('style');
        });
    };

    ns.toggleSupplementalTablesAndFigures = function () {
        $('.js-supplemental-figure-toggle').on('click',
            function (e) {
                e.preventDefault();
                var $target = $(e.currentTarget);
                var figId = $target.attr('data-id');
                var $targetGraphicWrapper = $(".js-supplemental-figure-graphic-wrap[data-id='" + figId + "']").first();
                toggleShowHide($targetGraphicWrapper);
                toggleExpandCollapse($target);
            });

        $('.js-supplemental-table-toggle').on('click', function (e) {
            e.preventDefault();
            var $target = $(e.currentTarget);
            var tableId = $target.attr('data-id');
            var $targetTableWrap = $('.js-supplemental-table-graphic-wrap[data-id="' + tableId + '"]');
            toggleShowHide($targetTableWrap);
            toggleExpandCollapse($target);
        });

        function toggleExpandCollapse(target) {
            var $expandViewSpan = target.find('.js-expand-view');
            var $collapseViewSpan = target.find('.js-collapse-view');

            if ($expandViewSpan.hasClass('supplemental-material-collapsed')) {
                $expandViewSpan.removeClass('supplemental-material-collapsed');
                $collapseViewSpan.addClass('supplemental-material-collapsed');
            }
            else {
                $expandViewSpan.addClass('supplemental-material-collapsed');
                $collapseViewSpan.removeClass('supplemental-material-collapsed');
            }
        }

        function toggleShowHide(wrapperElement) {
            if (wrapperElement.hasClass('supplemental-material-collapsed')) {
                wrapperElement.removeClass('supplemental-material-collapsed');
            }
            else {
                wrapperElement.addClass('supplemental-material-collapsed');
            }
        }
    };

    ns.myAccountCheckoutMessage = function () {
        if ($('.widget-MyAccount').length && $('.js-my-account-checkout-message').length) {
            var revealContent = $('.js-my-account-checkout-message').html().trim();
            var $modal = $('#revealModal');
            var $modalContent = $modal.find('#revealContent');
            if (!$modal.length || !$modalContent.length || !revealContent) {
                return;
            }
            $modalContent.empty().prepend(revealContent);
            $modalContent.find('.js-my-account-checkout-message').removeClass('hide');
            $body.addClass('on-canvas');
            $modal.addClass('open');
        }
    };

    ns.inlineGraphicWrap = function () {
        var parentContentSectionWrapper = $('.js-graphic-position-anchor').parents('.js-content-section');
        if (parentContentSectionWrapper.length > 0) {
            parentContentSectionWrapper.addClass('inline-graphic-image-wrap');
            parentContentSectionWrapper.next('.js-content-section').addClass('inline-graphic-text-wrap').after($("<div class='text-break'></div>"));
        }
    };


    // ----
    // Initialization functions
    // ----
    ns.init = function () {
        ns.checkForJS();
        ns.detectIfIE();
        ns.detectIfFirefox();
        ns.skipToMainContent();
        ns.hideAutoSuggestHintInputs();
        ns.globalNavDropdown();
        SCM.Logging.init();
        SCM.JqueryMigrateLogger.init();
        ns.initAriaControls();
        ns.initSearchResultsSort();
        ns.initSearchResultsPagination();
        SCM.Utilities.LazyLoad.init();
        SCM.AuthorLinks.init();
        ns.showFunderInfo();
        ns.hideFunderInfo();
        ns.showArticleMetadata();
        ns.scrollToAwardInfo();
        SCM.PubHistory.registerToggle();
        ns.showFullAuthorList();
        ns.addAuthorFootnote();
        ns.showHideDropDown();
        ns.showMoreRelatedContent('.grw-viewmorelink', '.grw-hide-me');
        ns.showMoreRelatedContent('.mrw-viewmorelink', '.mrw-hide-me');
        ns.showSpinner();
        ns.toggleResponsiveLeftColumn(); // renamed
        ns.restrictedImages();
        ns.moveCompetingInterestsSection();
        ns.initSigninForm(); // AJAX
        ns.initSelfServeNavigation();
        ns.toggleSelfServeNavigation();
        ns.setAllLinksTarget();
        ns.showPdfOnlyLink();
        SCM.gdprCookieBanner.init();
        ns.setScrollbarWidthProperty();
        ns.alignModalsVerically();
        setupFeaturedFigure();
        setupTablesViewLarge();
        SCM.Toolbar.stickyToolbar();
        ns.ckbSelectAll();
        ns.mobileNav();
        ns.toggleSupplementalTablesAndFigures();
        ns.inlineGraphicWrap();
        ns.jumpToPeerReview();
        ns.myAccountCheckoutMessage();
        ns.scrollToTarget();
        SCM.BookPartTitleFacet.init();
        SCM.BookPartTitleFacet.showAllItems();
        SCM.CollectionFacet.init();
        SCM.CollectionFacet.showAllItems();
        SCM.SearchAccessibility.init();
        SCM.HypothesisAccessibility.init();
        SCM.FocusRestore.init();
        SCM.ContentMetric.init();
    };

    ns.windowLoadInit = function () {
        ns.initDatePicker();
        ns.revealFigsTablesInModal();
        ns.showUnAuthenticatedSpans();
        ns.toggleSearchCover();
        ns.modalManager();
        ns.triggerFppOnRedirect();
        ns.closeModals();
        ns.checkForEmptyArticleLeftNav();
    };

    ns.initArticleTopInfoAccessOptions = function () {
        // e.g. /acn
        var siteName = window.location.pathname.substring(0, window.location.pathname.indexOf('/', 2));
        var signInUrl = siteName + '/sign-in?returnUrl=' + encodeURIComponent(window.location.pathname + window.location.search);

        var $options = $('.article-top-info-user-restricted-options');

        $options.find('.article-top-info-sign-in').attr('href', signInUrl);

    };
    
    ns.scrollToTarget = function () {
        var hash = window.location.hash;
        if (hash != '' && hash != undefined) {
            let escapedHash = hash.replace(/([;?%&,.+*~\':"!^$[\]()=>|\/@])/g,'\\$1');
            var target = $(escapedHash);
            var pixelOffset = 60;
            var $splitViewContent = $('.js-content-splitview');
            if (target.length && $splitViewContent.length) {
                var scroll = target.offset().top +
                    $splitViewContent.scrollTop() -
                    $splitViewContent.offsetParent().offset().top - pixelOffset;
                var $articleSplitView = $('.pg_articlesplitview');

                if (scroll > $('.splitview__wrapper').offset().top - 10) {
                    $articleSplitView.addClass('stuck js-stuck');
                    $articleSplitView.removeClass('sticky-splitview-nav js-sticky-splitview-nav');
                }
                else {
                    $articleSplitView.removeClass('stuck js-stuck');
                    $articleSplitView.addClass('sticky-splitview-nav js-sticky-splitview-nav');
                }
                $splitViewContent.scrollTop(target.offset().top +
                    $splitViewContent.scrollTop() -
                    $splitViewContent.offsetParent().offset().top - pixelOffset);
            }
        }        
    };
})(SCM.SiteJS = SCM.SiteJS || {}, jQuery, SCM.ArticleAccessIcons);


// ----
// Where all modules get initialized
// ----
// A closure around doc.ready, window.load, window resize, and Ajax Complete so we can safely use $
(function ($, undefined) {
    var $resizeTimer;
    var $pageColumnLeft = $('.page-column--left');
    var setMobileClass = function () {
        SCM.SiteJS.getViewportWidth() <= 1023 ? $pageColumnLeft.addClass('mobile') : $pageColumnLeft.removeClass('mobile');
    };

    // Window Resize Event
    // all functions contained within the the resize & scroll events should be throttled or debounced in some way.
    // Example in SCM.JSUtility.js;
    $(window).on('resize', function () {
        clearTimeout($resizeTimer);
        $resizeTimer = setTimeout(function () {
            setMobileClass();
            SCM.SiteJS.setScrollbarWidthProperty();
        }, 10); // in milliseconds
    });

    // Window Load Event: Images done loading
    $(window).on('load', function () {
        SCM.SiteJS.windowLoadInit();
        if ($('body').hasClass('pg_articlesplitview')) {
            SCM.SplitScreen && SCM.SplitScreen.ScrollToWindowHash();
            SCM.SplitScreen.JumpToPeerReviewTab();
        }

        if ($('.widget-Alerts').length || $('.js-contextual-alert-signup').length) {
            Theme.Alerts && Theme.Alerts.triggerAlertModalOnRedirect && Theme.Alerts.triggerAlertModalOnRedirect();
            Theme.Alerts && Theme.Alerts.triggerContextualAlertModalOnRedirect && Theme.Alerts.triggerContextualAlertModalOnRedirect();
        }

        if (!SCM.SplitScreen.isSplitScreen()) {
            Theme.HashHandler.scrollToSubSection();
        }
    });

    // Document Ready Event: DOM fully loaded
    $(function () {
        Theme.CrossmarkButton && Theme.CrossmarkButton.init && Theme.CrossmarkButton.init();
        setMobileClass();
        SCM.SiteJS.init(); // init general JS module for site
        SCM.Toolbar.init(); // init Toolbar module from client.toolbar.js
        SCM.PDFAccess.init(); // init PDF module from scm.sharedcontrols.pdfaccess.js
        SCM.SiteJS.setAccessIcons();
        SCM.FormWidget.init();
        // Before JumpLinks.init(): it decides whether to hide an empty jump-link widget from the list as rendered (NARN-24340).
        SCM.ImageDescriptionToggle && SCM.ImageDescriptionToggle.init && SCM.ImageDescriptionToggle.init();
        SCM.ImageDescriptionFragment && SCM.ImageDescriptionFragment.init && SCM.ImageDescriptionFragment.init();
        SCM.JumpLinks.init();
        SCM.CmsJumpLinks.init();
        SCM.AddReturnUrlToSocietyLinks();
        if ($('.widget-ArticleFulltext').length > 0) {
            SCM.ArticleFulltext.init();
        }
        SCM.SharedWidgets && SCM.SharedWidgets.GetFtrEntitlements && SCM.SharedWidgets.GetFtrEntitlements.init && SCM.SharedWidgets.GetFtrEntitlements.init();
        SCM.ArticleLinks.init();
        SCM.SeeAlso.init();
        if ($('body').hasClass('pg_articlesplitview')) {
            SCM.SplitScreen.init();
        }

        if ($('body').hasClass('pg_brightcove')) {
            SCM.Utilities.Brightcove.init();
        }
        if ($('.js-cadmore-embed-placeholder').length) {
            Theme.Utilities.Cadmore && Theme.Utilities.Cadmore.init && Theme.Utilities.Cadmore.init();
        }
        if ($('.widget-ShibbolethSignin').length) {
            Theme.ShibbolethSignin && Theme.ShibbolethSignin.init && Theme.ShibbolethSignin.init();
        }
        Theme.ShibbolethSignin && Theme.ShibbolethSignin.initSeamlessAccess && Theme.ShibbolethSignin.initSeamlessAccess();
        Theme.InstitutionSsoAuth && Theme.InstitutionSsoAuth.init && Theme.InstitutionSsoAuth.init();
        SCM.SubjectBrowse.init();
        SCM.JwPlayer && SCM.JwPlayer.init && SCM.JwPlayer.init();
        SCM.CompactAddToCartButton && SCM.CompactAddToCartButton.init && SCM.CompactAddToCartButton.init();
        SCM.NimbleAddToCart && SCM.NimbleAddToCart.init && SCM.NimbleAddToCart.init();
        SCM.Utilities && SCM.Utilities.Reveal && SCM.Utilities.Reveal.init();
        SCM.ToolboxGetCitations && SCM.ToolboxGetCitations.init && SCM.ToolboxGetCitations.init();
        Theme.Store && Theme.Store.init && Theme.Store.init();
        Theme.BuyThisResourceLink && Theme.BuyThisResourceLink.init && Theme.BuyThisResourceLink.init();
        Theme.BuyOrUseTokensLink && Theme.BuyOrUseTokensLink.init && Theme.BuyOrUseTokensLink.init();
        SCM.StripePayment && SCM.StripePayment.init && SCM.StripePayment.init();
        SCM.PaypalAdvancedPayment && SCM.PaypalAdvancedPayment.init && SCM.PaypalAdvancedPayment.init();
        SCM.Cybersource && SCM.Cybersource.UnifiedCheckout && SCM.Cybersource.UnifiedCheckout.init && SCM.Cybersource.UnifiedCheckout.init();
        SCM.Dropdowns && SCM.Dropdowns.init && SCM.Dropdowns.init();
        SCM.Modals && SCM.Modals.init && SCM.Modals.init();
        SCM.PersonalizedContent && SCM.PersonalizedContent.init && SCM.PersonalizedContent.init();
        SCM.TermsAndConditions && SCM.TermsAndConditions.init && SCM.TermsAndConditions.init();
        SCM.ArticleMainView.init();
        SCM.GiftAccessModals && SCM.GiftAccessModals.init && SCM.GiftAccessModals.init();
        SCM.GiftAccessModals && SCM.GiftAccessModals.checkForPostSignInModalOpen && SCM.GiftAccessModals.checkForPostSignInModalOpen();
        Theme.ArticleAbstract && Theme.ArticleAbstract.init && Theme.ArticleAbstract.init();
        Theme.BookAbstract && Theme.BookAbstract.init && Theme.BookAbstract.init();
        Theme.ChapterAbstract && Theme.ChapterAbstract.init && Theme.ChapterAbstract.init();
        Theme.ConferenceVolumeSelector && Theme.ConferenceVolumeSelector.init && Theme.ConferenceVolumeSelector.init();
        Theme.ContactUsForm && Theme.ContactUsForm.init && Theme.ContactUsForm.init();
        Theme.CookiePro && Theme.CookiePro.loadCookiesIfNotEnabled && Theme.CookiePro.loadCookiesIfNotEnabled();
        Theme.FreshChat && Theme.FreshChat.init && Theme.FreshChat.init();
        Theme.ToolboxEbook && Theme.ToolboxEbook.downloadEbookChapterPage && Theme.ToolboxEbook.downloadEbookChapterPage();
        Theme.NewAndPopular && Theme.NewAndPopular.init && Theme.NewAndPopular.init();
        Theme.CallsForSubmissions && Theme.CallsForSubmissions.init && Theme.CallsForSubmissions.init();
        Theme.PeerReview && Theme.PeerReview.init && Theme.PeerReview.init();
        Theme.StickyHeaderAd && Theme.StickyHeaderAd.init && Theme.StickyHeaderAd.init();
        Theme.StickyFooterAd && Theme.StickyFooterAd.init && Theme.StickyFooterAd.init();
        Theme.BackToTop && Theme.BackToTop.init && Theme.BackToTop.init();
        Theme.StickySidebarAd && Theme.StickySidebarAd.init && Theme.StickySidebarAd.init();
        Theme.InterstitialAd && Theme.InterstitialAd.init && Theme.InterstitialAd.init();
        Theme.RegisterUserModals && Theme.RegisterUserModals.init && Theme.RegisterUserModals.init();
        Theme.RegisterUserWorkflow && Theme.RegisterUserWorkflow.init && Theme.RegisterUserWorkflow.init();
        Theme.PdfCoverPage && Theme.PdfCoverPage.init && Theme.PdfCoverPage.init();
        Theme.OneTrustDarkOverlay && Theme.OneTrustDarkOverlay.init && Theme.OneTrustDarkOverlay.init();
        SCM.GoogleTagManagerDataLayerEvents && SCM.GoogleTagManagerDataLayerEvents.init && SCM.GoogleTagManagerDataLayerEvents.init();
        Theme.Utilities.YouTube && Theme.Utilities.YouTube.init && Theme.Utilities.YouTube.init();
        Theme.Utilities.VimeoVideo && Theme.Utilities.VimeoVideo.init && Theme.Utilities.VimeoVideo.init();
        SCM.Pendo && SCM.Pendo.logPageEvent && SCM.Pendo.logPageEvent();
        Theme.BookSectionEditors && Theme.BookSectionEditors.init && Theme.BookSectionEditors.init();
        SCM.WPSKevelAds && SCM.WPSKevelAds.init && SCM.WPSKevelAds.init();
        SCM.TapNative && SCM.TapNative.init && SCM.TapNative.init();
        Theme.Iqvia && Theme.Iqvia.init && Theme.Iqvia.init();
        SCM.DynamicDiscovery && SCM.DynamicDiscovery.init && SCM.DynamicDiscovery.init();

        if ($('.widget-W3cBookProductAccessibility').length) {
            SCM.SharedWidgets && SCM.SharedWidgets.W3cBookProductAccessibility && SCM.SharedWidgets.W3cBookProductAccessibility.init && SCM.SharedWidgets.W3cBookProductAccessibility.init();
        }

        if ($('.widget-InstitutionSignIn').length) {
            Theme.InstitutionSignIn && Theme.InstitutionSignIn.init && Theme.InstitutionSignIn.init();
        }

        if ($('.widget-ConferencesBrowseByYear').length) {
            Theme.ConferencesBrowseByYear && Theme.ConferencesBrowseByYear.init && Theme.ConferencesBrowseByYear.init();
        }

        if ($('.widget-MyAccount').length || $('.widget-RegisterUserWorkflow').length) {
            Theme.MyProfile && Theme.MyProfile.init && Theme.MyProfile.init();
            Theme.OrcidId && Theme.OrcidId.init && Theme.OrcidId.init();
        }

        if ($('.widget-MyInterests').length) {
            Theme.MyInterests && Theme.MyInterests.init && Theme.MyInterests.init();
        }

        if ($('.js-my-email-alerts').length) {
            Theme.MyEmailAlerts && Theme.MyEmailAlerts.init && Theme.MyEmailAlerts.init();
        }

        if ($('.widget-RegisterUser').length) {
            Theme.RegisterUser && Theme.RegisterUser.init && Theme.RegisterUser.init();
        }

        if ($('.current-issue-search').length) {
            Theme.SearchWithinIssue && Theme.SearchWithinIssue.init && Theme.SearchWithinIssue.init();
        }

        if ($('.solrSearchSaveWidget').length) {
            Theme.SolrSavedSearches && Theme.SolrSavedSearches.init && Theme.SolrSavedSearches.init();
        }

        if ($('.js-userComments').length) {
            Theme.UserComments && Theme.UserComments.init && Theme.UserComments.init();
        }

        if ($('.widget-EpubPdfViewerToolbar').length) {
            Theme.DocumentViewerToolbar && Theme.DocumentViewerToolbar.init && Theme.DocumentViewerToolbar.init();
        }

        if ($('.widget-GuestCheckout').length || $('.widget-RestoreGuestAccess')) {
            Theme.GuestCheckout && Theme.GuestCheckout.init && Theme.GuestCheckout.init();
        }

        if ($('.widget-CheckoutOptions').length) {
            Theme.StoreCheckoutOptions && Theme.StoreCheckoutOptions.init && Theme.StoreCheckoutOptions.init();
        }

        if ($('body').hasClass('pg_Issue') || $('body').hasClass('pg_IssueCovers')) {
            Theme.Issue && Theme.Issue.init && Theme.Issue.init();
            Theme.MeetingAbstractIssue && Theme.MeetingAbstractIssue.init && Theme.MeetingAbstractIssue.init();
        }

        if ($('body').hasClass('pg_book') || $('body').hasClass('pg_chapterstandard') || $('body').hasClass('pg_articlesplitview')) {
            Theme.CurrentBookSearch && Theme.CurrentBookSearch.init && Theme.CurrentBookSearch.init();
        }

        if ($('body').hasClass('pg_book')) {
            Theme.BookToc.init();
        }

        if ($('.widget-MultiQuerySelectableContentList').length) {
            Theme.MultiQuerySelectableContentList && Theme.MultiQuerySelectableContentList.init && Theme.MultiQuerySelectableContentList.init();
        }

        if ($('.widget-DeepDyve').length) {
           SCM.DeepDyve && SCM.DeepDyve.init();
        }

        if ($('.widget-AccountActionEmail').length) {
            SCM.MyAccount.initSendAccountActivationEmail();
        }

        if ($('.widget-Alerts').length || $('.js-contextual-alert-signup').length) {
            Theme.Alerts && Theme.Alerts.init && Theme.Alerts.init();
        }

        if ($('.widget-ArticleAiLayAbstract').length) {
            SCM.SharedWidgets.ArticleAiLayAbstract && SCM.SharedWidgets.ArticleAiLayAbstract.init();
        }

        if ($('.widget-TrendMD').length) {
            SCM.SharedWidgets.TrendMD.init();
        }
        
        if ($('.scite-badge').length) {
            SCM.SharedWidgets.Scite.init();
        }
        
        if (SCM.PageDesigner && SCM.PageDesigner.PostMessage && window.parent !== window) {
            SCM.PageDesigner.PostMessage.init();
        }
    });

    // Ajax Complete Event
    $(document).ajaxStart(function () {
        $('body').css('cursor', 'wait');

    }).ajaxComplete(function (event, xhr, settings) {
        // init foundation for new DOM elements after new HTML loaded through AJAX
        SCM.SiteJS.initSearchResultsSort();
        SCM.SolrSearch.ajaxComplete(settings);
        SCM.SiteJS.setAccessIcons();

        // Re-apply multi-path icons
        if (typeof App !== 'undefined' && App.SiteJS && typeof App.SiteJS.setupMultiPathIcons === 'function') {
            App.SiteJS.setupMultiPathIcons();
        }

        SCM.SiteJS.setAllLinksTarget();
        $('body').css('cursor', 'default');
        Theme.MathJax && Theme.MathJax.ajaxInit && Theme.MathJax.ajaxInit();
        SCM.Utilities.LazyLoad.init();
        SCM.SiteJS.alignModalsVerically();
    });

})(jQuery);